/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StaleEntryReferences } from './StaleEntryReferences';
import {
    StaleEntryReferencesFromJSON,
    StaleEntryReferencesFromJSONTyped,
    StaleEntryReferencesToJSON,
} from './StaleEntryReferences';

/**
 * 
 * @export
 * @interface DatabaseStaleReferencesReport
 */
export interface DatabaseStaleReferencesReport {
    /**
     * 
     * @type {string}
     * @memberof DatabaseStaleReferencesReport
     */
    databaseId?: string;
    /**
     * Gesamtzahl der gescannten Einträge in der Datenbank.
     * @type {number}
     * @memberof DatabaseStaleReferencesReport
     */
    scannedEntryCount?: number;
    /**
     * Nur Einträge, bei denen mindestens eine Stale-Reference gefunden wurde.
     * @type {Array<StaleEntryReferences>}
     * @memberof DatabaseStaleReferencesReport
     */
    entriesWithStaleReferences?: Array<StaleEntryReferences>;
}

/**
 * Check if a given object implements the DatabaseStaleReferencesReport interface.
 */
export function instanceOfDatabaseStaleReferencesReport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseStaleReferencesReportFromJSON(json: any): DatabaseStaleReferencesReport {
    return DatabaseStaleReferencesReportFromJSONTyped(json, false);
}

export function DatabaseStaleReferencesReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseStaleReferencesReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'databaseId': !exists(json, 'databaseId') ? undefined : json['databaseId'],
        'scannedEntryCount': !exists(json, 'scannedEntryCount') ? undefined : json['scannedEntryCount'],
        'entriesWithStaleReferences': !exists(json, 'entriesWithStaleReferences') ? undefined : ((json['entriesWithStaleReferences'] as Array<any>).map(StaleEntryReferencesFromJSON)),
    };
}

export function DatabaseStaleReferencesReportToJSON(value?: DatabaseStaleReferencesReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'databaseId': value.databaseId,
        'scannedEntryCount': value.scannedEntryCount,
        'entriesWithStaleReferences': value.entriesWithStaleReferences === undefined ? undefined : ((value.entriesWithStaleReferences as Array<any>).map(StaleEntryReferencesToJSON)),
    };
}

